import React from "react";
import { Link } from "react-router-dom";
import AccessoiresData from "../../../../api/AccessoiresData";

const BlogSidebar = ({ selectedAccesoire }) => {
  return (
    <div className={`col col-lg-4 col-12 order-lg-1`}>
      <div className="blog-sidebar">
        <div className="widget category-widget">
          <h3>Accesoires</h3>
          <ul>
            {AccessoiresData.map((acc) =>
              acc.id === selectedAccesoire.id ? (
                <li
                  className={`accesoires-links accesoires-links-active`}
                  key={acc.id}
                >
                  <Link to={`/accesoires/${acc.id}`}>{acc.title}</Link>
                </li>
              ) : (
                <li className={`accesoires-links`} key={acc.id}>
                  <Link to={`/accesoires/${acc.id}`}>{acc.title}</Link>
                </li>
              )
            )}
          </ul>
        </div>

        {/* <div className="widget about-widget">
          <h4>Accesoires</h4>
          <p>
            Short Description Lorem ipsum, dolor sit amet consectetur
            adipisicing elit. Natus, temporibus! Lorem ipsum dolor sit amet
            consectetur adipisicing elit. Esse, magnam. Lorem ipsum dolor sit,
            amet consectetur adipisicing elit. Est, quia.
          </p>

          <div className="aw-shape"></div>
        </div> */}
      </div>
    </div>
  );
};

export default BlogSidebar;
